import { BellIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useSidebarContext } from './Sidebar';
import { Bars3Icon } from '@heroicons/react/24/outline';

export default function Header() {
  const sidebarContext = useSidebarContext();
  const { isExpanded, setIsExpanded } = sidebarContext;

  return (
    <header className="bg-white shadow sticky top-0 z-20">
      <div className="flex h-16 items-center justify-between px-4 md:px-6">
        <div className="flex items-center">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="p-2 rounded-md text-gray-500 lg:hidden"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <h2 className="text-lg md:text-2xl font-semibold text-gray-900">
            RESILENT™ Cyber Crisis Management
          </h2>
        </div>
        <div className="flex items-center space-x-4">
          <div className="relative">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
              type="text"
              placeholder="Search..."
              className="hidden md:block w-64 rounded-md border-0 py-1.5 pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
          <button
            type="button"
            className="rounded-full bg-white p-2 text-gray-400 hover:text-gray-500"
          >
            <BellIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div>
            <img
              className="h-8 w-8 rounded-full"
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              alt="User avatar"
            />
          </div>
        </div>
      </div>
    </header>
  );
}